import React from 'react';
import appParameters from '../../../../utils/AppParameters';
import configuration from '../../../../../constants/Configuration';
import hoverManager from '../../../../utils/HoverManager';
import mouseUtils from '../../../../utils/MouseUtils';
import textEditorUtils from "../../utils/TextEditorUtils";

export const ColorElement = React.createClass({
    getInitialState() {
        return {
            isOver: false
        };
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        this.setState({
            isOver: false
        });
    },
    getColors() {
        let colorsArray = ['#c43025', '#eb1000', '#fe8b2e', '#f8fd32', '#008a27', '#1d7db4', '#9760a4', '#4a4c72', '#000000', '#ffffff', '#c0706e', '#ff9794', '#fcbc8d', '#fbfd8d', '#61df7e', '#7abae1', '#eca6fa', '#a0a7f1', '#969ba2'];
        let color = this.props.currentColor;

        if (colorsArray.indexOf(color) === -1) // if the color was selected with the colorPicker then we should replace the first bottom color with the correct one
            colorsArray[10] = color;

        return colorsArray;
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index === 19) { // open the colorPicker
            this.props.showColorPicker();
            return;
        }

        let colors = this.getColors();
        let selectedColor = colors[this.props.index];

        if (this.props.type === 'changeShapeFillColor') {
            if (this.props.index === 0)
                this.props.executeCommand('changeShapeFillVisibility');
            else
                this.props.executeCommand('changeShapeFillColor', selectedColor);
        } else if (this.props.type === 'changeShapeStrokeColor') {
            if (this.props.index === 0)
                this.props.executeCommand('changeShapeStrokeOpacity');
            else
                this.props.executeCommand('changeShapeStrokeColor', selectedColor);
        } else { // Font color
            textEditorUtils.executeAction(20, selectedColor);
            this.props.executeCommand('changeFontColor', selectedColor);
        }
    },
    isSelected() {
        let index;
        let colors = this.getColors();

        if (this.props.type === 'changeShapeFillColor') {
            if (!this.props.contextTarget.backgroundVisible) {
                if (this.props.index === 0)
                    return true;
            } else {
                index = colors.indexOf(this.props.contextTarget.fill);

                if (index === this.props.index)
                    return true;
            }
        } else if (this.props.type === 'changeShapeStrokeColor') { // stroke
            if (this.props.contextTarget.strokeOpacity === 0) {
                if (this.props.index === 0)
                    return true;
            } else {
                index = colors.indexOf(this.props.contextTarget.stroke);

                if (index === this.props.index)
                    return true;
            }
        } else { // Font Color
            index = colors.indexOf(this.props.currentColor);

            if (index === this.props.index)
                return true;
        }

        return false;
    },
    getIcon() {
        let host;

        if (configuration.LOAD_LOCAL === true)
            host = '';
        else
            host = appParameters.RESOURCES_LOCATION();

        switch(this.props.index) {
            case 0: { // No fill
                return host + 'assets/textEditor/noFill.png';
            }
            case 19: { // Plus
                return host + 'assets/textEditor/plus.svg';
            }
        }

        return '';
    },
    render() {
        const elementGap = 2;
        const size = this.props.width - elementGap;
        let topPosition = this.props.index < 10 ? 0 : size + elementGap;
        let index = this.props.index > 9 ? this.props.index - 10 : this.props.index;
        let leftPosition = index * (size + elementGap);

        topPosition = topPosition + this.props.top;

        let elementStyle = {
            position: 'absolute',
            width: size,
            height: size,
            top: topPosition,
            left: leftPosition,
            backgroundColor: 'white',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            cursor: 'pointer'
        };

        if (this.state.isOver) {
            elementStyle.backgroundColor = '#edefff';
            elementStyle.borderRadius = 5;
            elementStyle.borderWidth = 1;
            elementStyle.borderStyle = 'solid';
            elementStyle.borderColor = '#9ea2fd';
        } else
        if (this.isSelected()) {
            elementStyle.backgroundColor = '#edefff';
            elementStyle.borderRadius = 5;
            elementStyle.borderWidth = 1;
            elementStyle.borderStyle = 'solid';
            elementStyle.borderColor = '#2377bb';
        }

        const gap = 3;
        let colors = this.getColors();
        let centerStyle = {
            position: 'absolute',
            width: size - 2 * gap,
            height: size - 2 * gap,
            top: gap,
            left: gap,
            backgroundColor: colors[this.props.index],
            display: 'block',
            borderRadius: 50
        };

        let isNoFillButton = false;

        if ((this.props.type === 'changeShapeFillColor' || this.props.type === 'changeShapeStrokeColor') && this.props.index === 0)
            isNoFillButton = true;

        if (index === 9 || index === 19) { // white or plus element
            centerStyle.borderColor = '#c4c4c4';
            centerStyle.borderStyle = 'solid';
            centerStyle.borderWidth = 1;
            centerStyle.top = centerStyle.top - 1;
            centerStyle.left = centerStyle.left - 1;
        }

        let idValue = 'colorElement_' + this.props.index;
        let iconElement;

        if (this.props.index === 19 || isNoFillButton) {
            let iconStyle = {
                position: 'absolute',
                top: -1,
                left: -1,
                width: 25,
                height: 25,
                pointerEvents: 'none'
            };

            iconElement = <img alt='' aria-hidden='true' style={iconStyle} src={this.getIcon()}/>;
        }

        let ariaLabelValue;

        if (this.props.index === 19) {
            ariaLabelValue = hoverManager.getText('moreColors');

            if (this.props.type === 'changeShapeFillColor') {
                if (!this.props.contextTarget.isMindMap)
                    idValue = 'lastFocusableObjectForTextEditorTool';
            }
        } else
            ariaLabelValue = colors[this.props.index];

        return (
            <button id={idValue} aria-label={ariaLabelValue} style={elementStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onClick} onClick={this.onClick}>
                <span style={centerStyle}>
                    {iconElement}
                </span>
            </button>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/subcomponents/ColorElement.js
 **/